import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const sleepAndRestHeroBgGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-1',
    position: [10, 0],
    opacity: 0.3,
    size: 50,
  },
  {
    shape: 'circle',
    hex: '#8FA3B9',
    id: 'gradient-2',
    position: [75, 100],
    opacity: 0.2,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#8FA3B9',
    id: 'gradient-3',
    position: [99, 0],
    opacity: 0.2,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#384954',
    id: 'gradient-4',
    position: [99, 99],
    opacity: 0.5,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#8FA3B9',
    id: 'gradient-5',
    position: [38, 99],
    opacity: 0.1,
    size: 20,
  },
  {
    shape: 'ellipse',
    hex: '#8FA3B9',
    id: 'gradient-6',
    position: [70, 60],
    opacity: 0.1,
    size: 20,
  },
  {
    shape: 'ellipse',
    hex: '#172554',
    id: 'gradient-7',
    position: [10, 80],
    opacity: 0.1,
    size: 20,
  },
  {
    shape: 'ellipse',
    hex: '#8FA3B9',
    id: 'gradient-8',
    position: [70, 28],
    opacity: 0.2,
    size: 25,
  },
  {
    shape: 'ellipse',
    hex: '#384954',
    id: 'gradient-9',
    position: [0, 10],
    opacity: 1,
    size: 40,
  },
  {
    shape: 'ellipse',
    hex: '#8FA3B9',
    id: 'gradient-10',
    position: [0, 99],
    opacity: 0.3,
    size: 25,
  },
];

export default sleepAndRestHeroBgGradients;
